import $ from 'jquery';

function showConsentModal(subscription, url) {
    // show modal
    const modal = $('#updateSubscription');
    const subscriptionClass = subscription ? '.subscription' : '.unsuscription';

    modal.find('.ok,.message').hide();
    modal.find(`${subscriptionClass},.decline,.affirm`).show();
    modal.one('click', '.affirm', () => {
        // user click in yes
        const formData = {
            format: 'ajax',
            hpEmailSignUp: $('#hpEmailSignUp').val(),
        };

        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success(data) {
                const typeMessage = data.error ? '.error' : '.completed';
                modal.find('.message, .affirm, .decline').hide();
                modal.find(`.ok,${typeMessage}`).show();
                if (!data.error) {
                    $('#checkNewsletter').prop('checked', subscription);
                }
            },
            error() {
                modal.find('.affirm, .decline').hide();
                modal.find('.ok, .error').show();
            },
        });
    });
    modal.on('click', '.ok, .decline', () => {
        // user click in ok or cancel the modal (close modal)
        $('.modal').click();
    });
}

export default () => {
    $('#checkNewsletter').on('click', '', (e) => {
        // User click in checkbox and show the modal of confirm that depends on the state of button
        e.preventDefault();
        if ($(e.target).prop('checked') !== true) {
            showConsentModal(false, $(e.target).data('down'));
        } else {
            showConsentModal(true, $(e.target).data('up'));
        }
    });

    const $modal = $('#updateSubscription');
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const visibleFocusable = () => $modal.find(FOCUSABLE).filter(':visible');

    $modal.on('shown.bs.modal', () => {
        const $f = visibleFocusable();
        if ($f.length) $f.first().focus();
    });

    $modal.on('keydown', (e) => {
        if (e.key === 'Escape') {
            $modal.modal('hide');
            return;
        }
        if (e.key !== 'Tab') return;
        const $f = visibleFocusable();
        if (!$f.length) return;
        const first = $f[0];
        const last = $f[$f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });

    $modal.on('hidden.bs.modal', () => {
        $('#checkNewsletter').focus();
    });
};
